import { Component, ReactNode } from 'react';
import { createPortal } from 'react-dom';

import AsideContext, { AsidesContextValue } from '../BraxAsides/context';

let id = 1;

export type BraxAsideProps = {
    open: boolean,
    closeable: boolean,
    alwaysRender: boolean,
    children: ReactNode
};

type BraxAsideState = {
    open: boolean,
    closing: boolean
};

export class BraxAside extends Component<BraxAsideProps, BraxAsideState> {

    static defaultProps: Partial<BraxAsideProps> = {
        open: false,
        closeable: true,
        alwaysRender: true
    };

    static contextType = AsideContext;

    declare context: AsidesContextValue;

    state = {
        open: false,
        closing: false
    };

    id = (id++).toString();

    componentDidMount() {
        this.toggle();
    }

    componentDidUpdate(prevProps: BraxAsideProps) {
        if (prevProps.open !== this.props.open || prevProps.closeable !== this.props.closeable)
            this.toggle();
    }

    componentWillUnmount() {
        this.context.toggle(this.id, false, false);
    }

    toggle() {
        this.context.toggle(this.id, this.props.open, this.props.open && this.props.closeable);
    }

    render() {
        const aside = this.context.aside[this.id];

        if (!this.context.ref.current || !aside)
            return null;

        return aside.open || this.context.closing === this.id || this.props.alwaysRender
            ? createPortal(this.props.children, this.context.ref.current)
            : null;
    }

}
